import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiRequest, getUserDetails } from "../../services/apiRequest";
import { requestType } from "../../services/requests";
import { addToLoader } from "../loader/loaderSlice";

const initialState = {
    data: [],
    loading: true,
    error: false,
};

// The function below is called a thunk and allows us to perform async logic. It
// can be dispatched like a regular action: `dispatch(incrementAsync(10))`. This
// will call the thunk with the `dispatch` function as the first argument. Async
// code can then be executed and other actions can be dispatched. Thunks are
// typically used to make async requests.
export const getCustomerHolidayLinks = createAsyncThunk(
    "customerHolidayLinks/get",
    async (_, thunkAPI) => {
        thunkAPI.dispatch(addToLoader(true));
        const response = await apiRequest({
            payload: {
                data: {
                    user_uid: getUserDetails().user_details.uid,
                },
            },
            requestType: requestType.getCustomerHolidayLinks,
        });
        thunkAPI.dispatch(addToLoader(false));
        return response.data.data.customer_holiday_links;
    }
);

export const customerHolidayLinksSlice = createSlice({
    name: "customerHolidayLinks",
    initialState,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {},
    // The `extraReducers` field lets the slice handle actions defined elsewhere,
    // including actions generated by createAsyncThunk or in other slices.
    extraReducers: (builder) => {
        builder
            .addCase(getCustomerHolidayLinks.pending, (state) => {
                state.loading = true;
            })
            .addCase(getCustomerHolidayLinks.fulfilled, (state, { payload }) => {
                // When the API call is successful and we get some data,the data becomes the `fulfilled` action payload
                state.loading = false;
                state.data = payload;
            })
            .addCase(getCustomerHolidayLinks.rejected, (state) => {
                state.loading = false;
                state.error = true;
            });
    },
});

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.customerHolidayLinks.value)`
export const selectCustomerHolidayLinks = (state) => state.customerHolidayLinks;

// We can also write thunks by hand, which may contain both sync and async logic.
// Here's an example of conditionally dispatching actions based on current state.

export default customerHolidayLinksSlice.reducer;
